// src/components/payment/LockOverlay.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function LockOverlay({
  show,
  //  variant — default keeps existing behaviour unchanged
  variant = "locked", // "locked" | "comingSoon"
  to = "/payment",
  ctaKey = "activity.lockedCta",
  ctaDefault = "Unlock Results",
  ariaKey = "activity.lockedCtaAria",
  ariaDefault = "Go to checkout to unlock results",
  onClick,
  // (only used by comingSoon)
  soonKey = "activity.comingSoon",
  soonDefault = "Coming soon",
}) {
  const { t } = useTranslation();
  if (!show) return null;

  const isComingSoon = variant === "comingSoon";

  return (
    <div className="absolute inset-0 grid place-items-center bg-background/50 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-2 text-center">
        <span
          className="material-symbols-outlined text-[24px] text-primary"
          aria-hidden="true"
        >
          lock
        </span>

        {isComingSoon ? (
          <span
            className="rounded-full px-3 py-1 text-xs font-medium bg-primary/10 text-primary"
            aria-label={t(soonKey, { defaultValue: soonDefault })}
          >
            {t(soonKey, { defaultValue: soonDefault })}
          </span>
        ) : onClick ? (
          <button
            type="button"
            onClick={onClick}
            className="primary-button px-4 py-2"
            aria-label={t(ariaKey, { defaultValue: ariaDefault })}
          >
            {t(ctaKey, { defaultValue: ctaDefault })}
          </button>
        ) : (
          <Link
            to={to}
            className="primary-button px-4 py-2"
            aria-label={t(ariaKey, { defaultValue: ariaDefault })}
          >
            {t(ctaKey, { defaultValue: ctaDefault })}
          </Link>
        )}
      </div>
    </div>
  );
}
